import { useContext, useEffect, useState } from 'react';

import { Button, H4 } from '@selina-finance/ui';
import mixpanel from 'mixpanel-browser';
import { useNavigate } from 'react-router-dom';

import { ApplicationContext } from '@src/app/contexts/Application';
import { toCurrency } from '@src/shared/helpers';
import BackButton from '@src/ui/components/BackButton/BackButton';
import { CreateAccountModal } from '@src/ui/components/CreateAccountModal/CreateAccountModal';
import CheckEffectIcon from '@src/ui/components/Icons/CheckEffectIcon';
import ProgressMenu from '@src/ui/components/Progress/ProgressMenu';

const applicationBenefits: string[] = [
    'Some basic details about your co-owner',
    'Their contact details',
    'Their employment and income details',
];

export const AlmostCompleteView = () => {
    const { loanDetails, deferredApplicant2TestUser } =
        useContext(ApplicationContext);

    const navigate = useNavigate();

    const [openCreateAccountModal, setOpenCreateAccountModal] = useState(false);

    const loanAmount = toCurrency(loanDetails.amount || 0);

    useEffect(() => {
        mixpanel.track('almost_complete');
    }, []);

    const handleContinue = () => {
        mixpanel.track('tapped_continue_almost_complete');
        if (deferredApplicant2TestUser) {
            navigate('/eligibility/applicants2');
        }
    };

    const handleSaveForLater = () => {
        mixpanel.track('tapped_save_for_later_almost_complete');
        setOpenCreateAccountModal(true);
    };

    return (
        <div className='flex flex-row justify-between h-full'>
            <div className='flex flex-col h-full w-full sm:w-1/2 lg:w-2/5 mt-20 sm:mt-0 sm:mr-10 justify-between sm:justify-start'>
                <div>
                    <div className='hidden lg:block mb-2'>
                        <BackButton />
                    </div>
                    <p className='text-2xl lg:text-4xl font-sora-bold tracking-tighter'>
                        Your application for £{loanAmount} is almost complete
                    </p>
                    <div className='mt-3 mb-8'>
                        <p className='text-steel-100 text-body'>
                            Add your co-owners' details to finish your
                            application to see your offers.
                        </p>
                    </div>
                    <H4 className='font-bold'>What we’ll need</H4>
                    <div className='flex justify-between flex-col leading-6 mt-4'>
                        {applicationBenefits.map((it) => (
                            <div
                                key={it}
                                className='bg-white flex mb-2 p-3 rounded-full'
                            >
                                <div className='mr-2 flex items-center'>
                                    <CheckEffectIcon />
                                </div>
                                <p className='text-left text-sm_body leading-4'>
                                    {it}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='pt-6 mb-10 sm:mt-10 sm:pt-0'>
                    <Button
                        size='large'
                        color='tertiary-flat'
                        className='font-bold w-full text-lg'
                        onClick={handleSaveForLater}
                    >
                        <span className='text-lg'>Save and continue later</span>
                    </Button>
                    <Button
                        size='large'
                        color='secondary'
                        className='font-bold w-full mt-4 text-lg'
                        onClick={handleContinue}
                    >
                        <span className='text-lg'>Continue</span>
                    </Button>
                </div>
            </div>
            <ProgressMenu />
            <CreateAccountModal
                open={openCreateAccountModal}
                onClose={() => setOpenCreateAccountModal(false)}
            />
        </div>
    );
};
